<template>
  <div>
    <section class="information-section pc-info" id="information">
      <div class="information-container">
        <header class="info-section-header section-title-wrapper">
          <div class="info-title-wrapper">
            <div class="title-left">
              <h1 class="section-title" v-text="$t('home.info_title')"></h1>
            </div>
            <div class="info-more">
              <a href="/info">{{$t('home.info_more')}}</a>
            </div>
          </div>
        </header>
        <div class="infocontent">
          <div class="info-wrapper" v-for="item in articlesList" :key="item.id">
            <div class="info-item-img-wrapper">
              <div class="img-crop">
                <div class="info-item-img" :style="'background-image:url('+item.thumbnail+')'"></div>
              </div>
            </div>
            <div class="info-content">
              <div class="info-inner-content">
                <header>
                  <div
                    class="info-date"
                    v-text="item.publishTime.substring(0,10).replace(/-/g,'.')"
                  ></div>
                  <div class="info-title" v-text="item.title"></div>
                </header>
                <div class="info-des">
                  <p v-text="item.summary"></p>
                </div>
                <a :href="'/info_detail?no='+item.id" class="info-detail-btn" v-text="$t('detail')"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="wap-info" id="wap_information">
      <div class="info-container">
        <header class="wap-title-wrapper">
          <div class="wap-title-left">
            <div class="wap-section-sub-title" v-text="$t('home.info_title')"></div>
<!--            <div class="wap-section-sub-title" v-text="$t('home.info_sub_title')"></div>-->
          </div>
          <div class="title-more">
            <a href="/info">
              {{$t('home.info_more')}}
              <div class="wap-more-arrow"></div>
            </a>
          </div>
        </header>
        <div class="infocontent">
          <a
            class="info-wrapper"
            v-for="item in articlesList"
            :key="item.id"
            :href="'/info_detail?no='+item.id"
          >
            <div class="info-img-wrapper">
              <div class="img-crop">
                <div class="info-img" :style="'background-image:url('+item.thumbnail+')'"></div>
              </div>
            </div>
            <div class="info-content">
              <div class="info-inner-content">
                <div class="info-date" v-text="item.publishTime.substring(0,10).replace(/-/g,'.')"></div>
                <div class="info-title" v-text="item.title"></div>
                <div class="info-des">
                  <p v-text="item.summary"></p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "../common/common";
import { animationScroll } from "@/assets/js/common";
import { getHomeArticlesList } from "../../../request/api";
export default {
  data() {
    return {
      articlesList: []
    };
  },
  methods: {
    init() {
      this.getArticlesList();
    },
    getArticlesList() {
      var that = this;
      var localArticlesList = localStorage.getItem("articlesList");
      var lang = this.$cookies.get("language");
      if (localArticlesList) {
        //先读取缓存的banner图
        that.articlesList = JSON.parse(localArticlesList);
      }
      getHomeArticlesList({ language: lang||global.initLang })
        .then(res => {
          if (res.success) {
            that.articlesList = res.articlesList;
            localStorage.setItem(
              "articlesList",
              JSON.stringify(res.articlesList)
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.init();
    var _this = this;
    animationScroll($(".information-container"));
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/informationSection.vue